<template>
  <div class="recharge-page">
    <top-bar :title="$t('assest.label10')" @back="back"></top-bar>

    <div class="recharge-main">
      <div class="page-form">
        <div class="form-item">
          <div class="label">{{ $t("exchange.label1") }}</div>
          <div class="input">
            <Field
              v-model="form.fromCurrency"
              readonly
              :placeholder="$t('qing-xuan-ze-0')"
              @click="showFromPicker = true"
            >
              <template slot="right-icon">
                <Icon name="arrow-down" />
              </template>
            </Field>
          </div>
        </div>

        <div class="form-item">
          <div class="label">{{ $t("exchange.label3") }}</div>
          <div class="input">
            <Field
              v-model="form.fromAmount"
              type="number"
              :placeholder="$t('exchange.labelPlaceholder3')"
              @input="calculateToAmount"
            >
              <template slot="button">
                <Button size="small" type="primary" @click="setAll">
                  {{ $t("exchange.label5") }}
                </Button>
              </template>
            </Field>
          </div>
          <div class="desc-line">
            <span>{{ $t("exchange.label6") }}：</span>
            <span class="count"
              >{{ resetMoney(userBalance) }} {{ form.fromCurrency }}</span
            >
          </div>
        </div>

        <div class="img-line" @click="switchCurrency">
          <Icon name="exchange" size="24" />
        </div>

        <div class="form-item">
          <div class="label">{{ $t("exchange.label2") }}</div>
          <div class="input">
            <Field
              v-model="form.toCurrency"
              readonly
              :placeholder="$t('qing-xuan-ze-1')"
              @click="openToPicker"
            >
              <template slot="right-icon">
                <Icon name="arrow-down" />
              </template>
            </Field>
          </div>
        </div>

        <div class="form-item">
          <div class="label">{{ $t("exchange.label4") }}</div>
          <div class="input disabled">
            <Field
              v-model="form.toAmount"
              readonly
              :placeholder="$t('exchange.labelPlaceholder2')"
            />
          </div>
          <div class="desc-line">
            <span>{{ $t("exchange.label7") }}：</span>
            <span class="count"
              >1 {{ form.fromCurrency }} ≈ {{ exchangeRate }}
              {{ form.toCurrency }}</span
            >
          </div>
        </div>

        <div class="btn">
          <Button type="primary" block @click="submit">
            {{ $t("exchange.btn") }}
          </Button>
        </div>
      </div>
    </div>

    <div class="space-line"></div>

    <div class="sub-title">{{ $t("quan-bu-shan-dui-ji-lu") }}</div>

    <div class="list-table">
      <div class="th-line">
        <div class="th">{{ $t("exchange.label8") }}</div>
        <div class="th">{{ $t("chart_page.time") }}</div>
        <div class="th">{{ $t("finance.label12") }}</div>
      </div>
      <div class="tbody">
        <div class="td-line" v-for="(item, i) in logList" :key="i">
          <div class="td">
            <div class="currency-pair">
              <img
                :src="'/upload/' + item.FromCurrency.Logo"
                alt=""
                class="currency-icon"
              />
              <span
                >{{ item.FromCurrency.ShortName }} →
                {{ item.ToCurrency.ShortName }}</span
              >
            </div>
            <div class="amounts">
              <div>
                {{ parseFloat(item.FromAmount).toFixed(4) }}
                {{ item.FromCurrency.ShortName }}
              </div>
              <div>
                {{ parseFloat(item.ToAmount).toFixed(4) }}
                {{ item.ToCurrency.ShortName }}
              </div>
            </div>
          </div>
          <div class="td">{{ formatTime(item.CreatedAt) }}</div>
          <div class="td">
            <span class="status-success">{{ i18n.t("exchange.success") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="logList.length === 0" class="empty-data">
      <Empty description="暂无记录" />
    </div>

    <!-- 币种选择器 -->
    <Popup
      v-model="showFromPicker"
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="currency-picker">
        <div class="picker-header">
          <div class="picker-title">{{ $t("exchange.label1") }}</div>
          <div class="picker-close" @click="showFromPicker = false">×</div>
        </div>
        <div class="search-box">
          <Field
            v-model="fromSearchKeyword"
            :placeholder="$t('sou-suo-bi-zhong')"
            @input="filterFromCurrency"
          >
            <template slot="left-icon">
              <Icon name="search" />
            </template>
          </Field>
        </div>
        <div class="currency-list">
          <div
            v-for="(item, index) in filteredFromCurrencyList"
            :key="index"
            class="currency-item"
            @click="selectFromCurrency(item)"
          >
            <img
              :src="'/upload/' + item.Currency.Logo"
              alt=""
              class="currency-icon"
            />
            <div class="currency-info">
              <div class="currency-name">{{ item.Currency.ShortName }}</div>
              <div class="currency-balance">
                {{ $t("exchange.label6") }}:
                {{
                  resetMoney(
                    parseFloat(item.CapitalUse || 0) +
                      parseFloat(item.CapitalFree || 0)
                  )
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>

    <Popup v-model="showToPicker" position="bottom" :style="{ height: '60%' }">
      <div class="currency-picker">
        <div class="picker-header">
          <div class="picker-title">{{ $t("exchange.label2") }}</div>
          <div class="picker-close" @click="showToPicker = false">×</div>
        </div>
        <div class="search-box">
          <Field
            v-model="toSearchKeyword"
            :placeholder="$t('sou-suo-bi-zhong')"
            @input="filterToCurrency"
          >
            <template slot="left-icon">
              <Icon name="search" />
            </template>
          </Field>
        </div>
        <div class="currency-list">
          <div
            v-for="(item, index) in filteredToCurrencyList"
            :key="index"
            class="currency-item"
            @click="selectToCurrency(item)"
          >
            <img
              :src="'/upload/' + item.Currency.Logo"
              alt=""
              class="currency-icon"
            />
            <div class="currency-info">
              <div class="currency-name">{{ item.Currency.ShortName }}</div>
              <div class="currency-balance">
                {{ $t("exchange.label6") }}:
                {{
                  resetMoney(
                    parseFloat(item.CapitalUse || 0) +
                      parseFloat(item.CapitalFree || 0)
                  )
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import { Field, Button, Icon, Popup, Picker, Empty } from "vant";
import topBar from "@/components/topBar";
import { wallet, exchange, exchangeLog } from "@/api/assest";
import { getExchangeRate } from "@/api/index";

export default {
  components: {
    Field,
    Button,
    Icon,
    Popup,
    Picker,
    Empty,
    topBar,
  },
  data() {
    return {
      form: {
        fromCurrency: "",
        toCurrency: "",
        fromCurrencyId: 0,
        toCurrencyId: 0,
        fromAmount: "",
        toAmount: "",
      },
      userBalance: 0,
      exchangeRate: "0.00",
      currencyList: [],
      showFromPicker: false,
      showToPicker: false,
      fromSearchKeyword: "",
      toSearchKeyword: "",
      filteredFromCurrencyList: [],
      filteredToCurrencyList: [],
      page: {
        page: 1,
        limit: 10,
        total: 1,
      },
      logList: [],
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getCurrencyList();
      this.getExchangeLog();
    },

    back() {
      this.$router.go(-1);
    },

    resetMoney(val) {
      return parseFloat(val || 0).toFixed(4);
    },

    // 获取币种列表
    getCurrencyList() {
      wallet({
        current: 1,
        pageSize: 200,
      })
        .then((res) => {
          let items = res.data.Items || [];
          this.currencyList = items.filter((item) => {
            return item.Currency && item.Currency.ShortName;
          });

          // 按余额从高到低排序，余额相同时按币种名称排序
          this.currencyList.sort((a, b) => {
            const balanceA =
              parseFloat(a.CapitalUse || 0) + parseFloat(a.CapitalFree || 0);
            const balanceB =
              parseFloat(b.CapitalUse || 0) + parseFloat(b.CapitalFree || 0);

            // 先按余额排序（从高到低）
            if (balanceB !== balanceA) {
              return balanceB - balanceA;
            }

            // 余额相同时按币种名称排序
            return a.Currency.ShortName.localeCompare(b.Currency.ShortName);
          });

          // 初始化搜索列表
          this.filteredFromCurrencyList = [...this.currencyList];
          this.filteredToCurrencyList = [...this.currencyList];

          // 默认选择第一个币种作为兑换币种
          if (this.currencyList.length > 0) {
            const firstCurrency = this.currencyList[0].Currency;
            this.form.fromCurrency = firstCurrency.ShortName;
            this.form.fromCurrencyId = firstCurrency.ID;
            console.log(
              "默认选择源币种:",
              this.form.fromCurrency,
              "ID:",
              this.form.fromCurrencyId
            );
            this.getUserBalance();

            // 默认选择USDT作为目标币种（如果存在且不是源币种）
            const usdtIndex = this.currencyList.findIndex(
              (item) =>
                item.Currency.ShortName.toUpperCase() === "USDT" &&
                item.Currency.ID !== this.form.fromCurrencyId
            );
            if (usdtIndex > -1) {
              const usdtCurrency = this.currencyList[usdtIndex].Currency;
              this.form.toCurrency = usdtCurrency.ShortName;
              this.form.toCurrencyId = usdtCurrency.ID;
            } else if (this.currencyList.length > 1) {
              // 如果没有USDT或USDT是源币种，选择第二个币种
              const secondCurrency = this.currencyList[1].Currency;
              this.form.toCurrency = secondCurrency.ShortName;
              this.form.toCurrencyId = secondCurrency.ID;
            }
            console.log(
              "默认选择目标币种:",
              this.form.toCurrency,
              "ID:",
              this.form.toCurrencyId
            );

            // 获取初始汇率
            this.getRate();
          }
        })
        .catch((err) => {
          console.error("获取币种列表失败:", err);
          this.$toast.fail("获取币种列表失败");
        });
    },

    // 添加调试方法
    debugCurrentState() {
      console.log("=== 当前状态调试 ===");
      console.log(
        "源币种:",
        this.form.fromCurrency,
        "ID:",
        this.form.fromCurrencyId
      );
      console.log(
        "目标币种:",
        this.form.toCurrency,
        "ID:",
        this.form.toCurrencyId
      );
      console.log("兑换数量:", this.form.fromAmount);
      console.log("兑换汇率:", this.exchangeRate);
      console.log("兑换后数量:", this.form.toAmount);
      console.log("用户余额:", this.userBalance);
      console.log("===================");
    },

    getUserBalance() {
      if (!this.form.fromCurrency) return;

      const currentWallet = this.currencyList.find(
        (item) => item.Currency.ShortName === this.form.fromCurrency
      );

      if (currentWallet) {
        this.userBalance =
          parseFloat(currentWallet.CapitalUse || 0) +
          parseFloat(currentWallet.CapitalFree || 0);
      } else {
        this.userBalance = 0;
      }
    },

    getRate() {
      if (
        this.form.fromCurrencyId &&
        this.form.toCurrencyId &&
        this.form.fromCurrencyId !== this.form.toCurrencyId
      ) {
        // 检查是否是 USDT <-> USDC 兑换，使用固定汇率 1:1
        const fromCurrencyUpper = this.form.fromCurrency.toUpperCase();
        const toCurrencyUpper = this.form.toCurrency.toUpperCase();

        if (
          (fromCurrencyUpper === "USDT" && toCurrencyUpper === "USDC") ||
          (fromCurrencyUpper === "USDC" && toCurrencyUpper === "USDT")
        ) {
          // USDT <-> USDC 固定汇率 1:1
          this.exchangeRate = "1.00000000";
          console.log(
            `USDT <-> USDC 固定汇率: 1 ${this.form.fromCurrency} = 1 ${this.form.toCurrency}`
          );
          // 重新计算兑换数量
          this.calculateToAmount();
          // 调试当前状态
          this.debugCurrentState();
          return;
        }

        // 获取所有交易数据
        getExchangeRate({})
          .then((res) => {
            const tradesList = res.data || [];
            console.log("获取到的交易数据:", tradesList);

            let fromPrice = 1; // 源币种的USDT价格
            let toPrice = 1; // 目标币种的USDT价格

            // 获取USDT的币种ID（假设USDT的ID是固定的，或者从币种列表中查找）
            const usdtCurrency = this.currencyList.find(
              (item) => item.Currency.ShortName.toUpperCase() === "USDT"
            );
            const usdtId = usdtCurrency ? usdtCurrency.Currency.ID : 3; // 默认USDT ID为3

            // 获取源币种的USDT价格
            if (this.form.fromCurrencyId === usdtId) {
              fromPrice = 1;
            } else {
              const fromTrade = tradesList.find(
                (trade) => trade.CurrencyId === this.form.fromCurrencyId
              );
              if (fromTrade && fromTrade.Price) {
                fromPrice = parseFloat(fromTrade.Price);
                console.log(
                  `${this.form.fromCurrency} (ID:${this.form.fromCurrencyId}) 价格:`,
                  fromPrice
                );
              } else {
                console.error(
                  `未找到币种ID ${this.form.fromCurrencyId} (${this.form.fromCurrency}) 的价格数据`
                );
                this.exchangeRate = "0.00000000";
                return;
              }
            }

            // 获取目标币种的USDT价格
            if (this.form.toCurrencyId === usdtId) {
              toPrice = 1;
            } else {
              const toTrade = tradesList.find(
                (trade) => trade.CurrencyId === this.form.toCurrencyId
              );
              if (toTrade && toTrade.Price) {
                toPrice = parseFloat(toTrade.Price);
                console.log(
                  `${this.form.toCurrency} (ID:${this.form.toCurrencyId}) 价格:`,
                  toPrice
                );
              } else {
                console.error(
                  `未找到币种ID ${this.form.toCurrencyId} (${this.form.toCurrency}) 的价格数据`
                );
                this.exchangeRate = "0.00000000";
                return;
              }
            }

            // 计算汇率：1个源币种能兑换多少个目标币种
            const rate = fromPrice / toPrice;
            this.exchangeRate = rate.toFixed(8);

            console.log(`汇率计算: ${fromPrice} / ${toPrice} = ${rate}`);
            console.log(
              `最终汇率: 1 ${this.form.fromCurrency} = ${this.exchangeRate} ${this.form.toCurrency}`
            );

            // 重新计算兑换数量
            this.calculateToAmount();

            // 调试当前状态
            this.debugCurrentState();
          })
          .catch((err) => {
            console.error("获取交易价格失败:", err);
            this.exchangeRate = "0.00000000";
          });
      } else {
        this.exchangeRate = "0.00000000";
      }
    },

    // 搜索过滤方法
    filterFromCurrency() {
      const keyword = this.fromSearchKeyword.toLowerCase();
      if (!keyword) {
        this.filteredFromCurrencyList = [...this.currencyList];
      } else {
        this.filteredFromCurrencyList = this.currencyList.filter(
          (item) =>
            item.Currency.ShortName.toLowerCase().includes(keyword) ||
            item.Currency.FullName?.toLowerCase().includes(keyword)
        );
      }
    },

    filterToCurrency() {
      const keyword = this.toSearchKeyword.toLowerCase();
      let list = this.currencyList.filter(
        (item) => item.Currency.ID !== this.form.fromCurrencyId
      );

      if (!keyword) {
        this.filteredToCurrencyList = list;
      } else {
        this.filteredToCurrencyList = list.filter(
          (item) =>
            item.Currency.ShortName.toLowerCase().includes(keyword) ||
            item.Currency.FullName?.toLowerCase().includes(keyword)
        );
      }
    },

    // 选择币种方法
    selectFromCurrency(item) {
      console.log(
        "选择源币种:",
        item.Currency.ShortName,
        "ID:",
        item.Currency.ID
      );
      this.form.fromCurrency = item.Currency.ShortName;
      this.form.fromCurrencyId = item.Currency.ID;
      console.log("源币种ID:", this.form.fromCurrencyId);
      this.getUserBalance();

      // 如果还没有选择目标币种，或者目标币种与源币种相同，才清空输入
      if (
        !this.form.toCurrencyId ||
        this.form.fromCurrencyId === this.form.toCurrencyId
      ) {
        this.form.fromAmount = "";
        this.form.toAmount = "";
      }

      // 更新目标币种列表，排除当前选择的源币种
      this.filterToCurrency();

      this.getRate();
      this.showFromPicker = false;
      this.fromSearchKeyword = "";
    },

    selectToCurrency(item) {
      console.log(
        "选择目标币种:",
        item.Currency.ShortName,
        "ID:",
        item.Currency.ID
      );
      this.form.toCurrency = item.Currency.ShortName;
      this.form.toCurrencyId = item.Currency.ID;
      console.log("目标币种ID:", this.form.toCurrencyId);
      // 不清空输入金额，保持用户体验
      // this.form.fromAmount = ''
      // this.form.toAmount = ''
      this.getRate();
      this.showToPicker = false;
      this.toSearchKeyword = "";
    },

    openToPicker() {
      this.filterToCurrency();
      this.showToPicker = true;
    },

    calculateToAmount() {
      if (
        this.form.fromAmount &&
        this.exchangeRate &&
        parseFloat(this.exchangeRate) > 0
      ) {
        const fromAmount = parseFloat(this.form.fromAmount);
        const rate = parseFloat(this.exchangeRate);
        const toAmount = fromAmount * rate;
        this.form.toAmount = toAmount.toFixed(8);
        console.log(`兑换计算: ${fromAmount} × ${rate} = ${toAmount}`);
      } else {
        this.form.toAmount = "";
        console.log("计算条件不满足:", {
          fromAmount: this.form.fromAmount,
          exchangeRate: this.exchangeRate,
          rateValue: parseFloat(this.exchangeRate),
        });
      }
    },

    switchCurrency() {
      if (!this.form.fromCurrencyId || !this.form.toCurrencyId) return;

      console.log(
        "切换币种前:",
        this.form.fromCurrency,
        "(ID:",
        this.form.fromCurrencyId,
        ") ->",
        this.form.toCurrency,
        "(ID:",
        this.form.toCurrencyId,
        ")"
      );

      // 交换币种名称和ID
      const tempName = this.form.fromCurrency;
      const tempId = this.form.fromCurrencyId;
      this.form.fromCurrency = this.form.toCurrency;
      this.form.fromCurrencyId = this.form.toCurrencyId;
      this.form.toCurrency = tempName;
      this.form.toCurrencyId = tempId;

      console.log(
        "切换币种后:",
        this.form.fromCurrency,
        "(ID:",
        this.form.fromCurrencyId,
        ") ->",
        this.form.toCurrency,
        "(ID:",
        this.form.toCurrencyId,
        ")"
      );

      this.form.fromAmount = "";
      this.form.toAmount = "";
      this.getUserBalance();
      this.getRate();
    },

    setAll() {
      this.form.fromAmount = this.userBalance.toString();
      this.calculateToAmount();
    },

    submit() {
      if (!this.form.fromAmount || parseFloat(this.form.fromAmount) <= 0) {
        this.$toast.fail(this.$t("exchange.error1"));
        return;
      }

      if (parseFloat(this.form.fromAmount) > parseFloat(this.userBalance)) {
        this.$toast.fail(this.$t("exchange.error2"));
        return;
      }

      if (this.form.fromCurrencyId === this.form.toCurrencyId) {
        this.$toast.fail(this.$t("exchange.error3"));
        return;
      }

      exchange({
        fromCurrencyId: this.form.fromCurrencyId,
        toCurrencyId: this.form.toCurrencyId,
        fromAmount: this.form.fromAmount,
        // 移除toAmount和rate，由服务端计算
        // toAmount: this.form.toAmount,
        // rate: this.exchangeRate
      })
        .then((res) => {
          if (res.code === 0) {
            this.$toast.success(this.$t("exchange.success_msg"));
            this.form.fromAmount = "";
            this.form.toAmount = "";
            this.getCurrencyList();
            this.getExchangeLog();
          } else {
            this.$toast.fail(res.msg || this.$t("exchange.error4"));
          }
        })
        .catch((err) => {
          this.$toast.fail(err.message || this.$t("exchange.error4"));
        });
    },

    getExchangeLog() {
      exchangeLog({
        page: this.page.page,
        limit: this.page.limit,
      })
        .then((res) => {
          this.logList = res.data.Items || [];
          this.page.total = res.data.Count || 0;
        })
        .catch(() => {
          this.logList = [];
        });
    },

    formatTime(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString();
    },
  },
};
</script>

<style scoped>
.recharge-page {
  width: 375px;
  padding: 16px 16px 20px;
  padding-bottom: calc(20px + constant(safe-area-inset-bottom));
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  background: #f6f7f8;
  min-height: 100vh;
}

.recharge-main {
  width: 100%;
  padding-top: 1rem;
}

.page-form {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

.form-item {
  margin-bottom: 20px;
}

.form-item .label {
  font-size: 14px;
  color: #353945;
  line-height: 22px;
  margin-bottom: 8px;
  font-weight: 500;
}

.input {
  position: relative;
}

.input.disabled {
  opacity: 0.6;
}

.desc-line {
  margin-top: 8px;
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.desc-line .count {
  color: #f7a600;
  font-weight: 500;
}

.img-line {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  cursor: pointer;
  padding: 10px;
}

.img-line .van-icon {
  color: #f7a600;
  transform: rotate(90deg);
}

.btn {
  margin-top: 30px;
}

.space-line {
  width: calc(100% + 32px);
  height: 8px;
  background: #f6f7f8;
  margin: 20px 0 20px -16px;
}

.sub-title {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  line-height: 18px;
  margin-bottom: 12px;
  padding: 0 4px;
}

.list-table {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}

.th-line {
  display: flex;
  background: #f8f9fa;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.th {
  flex: 1;
  font-size: 12px;
  color: #85898f;
  font-weight: 500;
}

.tbody {
  padding: 0;
}

.td-line {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.td-line:last-child {
  border-bottom: none;
}

.td {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.currency-pair {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.currency-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 8px;
}

.amounts {
  font-size: 12px;
  color: #666;
}

.amounts div {
  margin-bottom: 4px;
}

.amounts div:last-child {
  margin-bottom: 0;
}

.status-success {
  color: #4cd964;
  font-size: 12px;
  font-weight: 500;
}

.empty-data {
  background: #fff;
  border-radius: 12px;
  padding: 40px 20px;
  text-align: center;
  margin-top: 12px;
}

/* Vant组件样式覆盖 */
.recharge-page /deep/ .van-field {
  padding: 12px 0;
}

.recharge-page /deep/ .van-field__control {
  font-size: 16px;
  color: #333;
}

.recharge-page /deep/ .van-field__control::placeholder {
  color: #c8c9cc;
}

.recharge-page /deep/ .van-button--primary {
  background: #f7a600;
  border-color: #f7a600;
  color: #000;
  font-weight: 600;
  height: 50px;
  border-radius: 10px;
}

.recharge-page /deep/ .van-button--small {
  height: 32px;
  padding: 0 12px;
  font-size: 12px;
  border-radius: 6px;
}

.recharge-page /deep/ .van-picker {
  background: #fff;
}

.recharge-page /deep/ .van-popup {
  border-radius: 12px 12px 0 0;
}

/* 币种选择器样式 */
.currency-picker {
  background: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
}

.picker-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.picker-close {
  font-size: 24px;
  color: #999;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-box {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #f8f9fa;
}

.currency-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

.currency-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.currency-item:hover {
  background-color: #f8f9fa;
}

.currency-item:active {
  background-color: #f0f0f0;
}

.currency-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
}

.currency-info {
  flex: 1;
}

.currency-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.currency-balance {
  font-size: 12px;
  color: #666;
}
</style>
